import { Img } from "components";
import TextArea from "../components/TextArea";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useSpotlight } from 'react-spotlight-tour';
import { useSpotlight } from "../components/SpotLight";
import BhashaniVideo from "../components/BhashaniVideo";
import CommunicationModal from "../components/CommunicationModal";
import Stepper from "../components/Stepper";
import AvatarVideo from "../components/AvatarVideo";
import Wrapper from "../components/Wrapper";

const customStylesRefer = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "40rem", // Adjusted for responsiveness
        maxWidth: "90%", // Added to maintain a max width
        minHeight: "6rem",
        borderRadius: "1em",
        boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
        padding: "10px 0px",
        border: "0px",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: "999",
    },
    "@media (min-width: 768px)": {
        content: {
            width: "75%", // Adjusted for tablet view
        },
    },
    "@media (min-width: 1024px)": {
        content: {
            width: "55rem", // Original width for desktop view
        },
    },
};

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/comm-solution.mp4" },
    // {url: "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/seralynne/intro.mp4?id=1"},
    // {url: "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/seralynne/intro.mp4?id=2"}
]

const CommPage3 = () => {
    const navigate = useNavigate();
    // const videoRef = useRef(null);
    const [position, setPosition] = useState(0);

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");

    return (
        <Wrapper
            title={"Communications Made Easy"}
            description="🚫 Say NO to outdated methods that cause delays, confusion, and lost opportunities."
            descriptionSize="text-[2.5vh]"
            videoLinks={videoLinks}
            body={<>
                <div className="font-inter flex justify-center">
                    <div className="w-fit bg-smd_white-normal border-2 border-smd_blue-normal rounded-3xl py-4 px-8">
                        <p className="text-smd_blue-normal text-[2.5vh] font-manropeB">The Solution — Speak Their Language</p>
                    </div>
                </div>
                <div className="font-inter flex justify-center">
                    <div className="w-[65%] bg-smd_white-normal rounded-3xl p-6 text-[#081B34] space-y-6 border border-smd_golden-light">
                        <p className="text-[2.5vh]"><span className="text-[2.5vh] font-manropeB text-[black] tracking-wide">Regional Language Support →</span>Our automated IVR system delivers messages in each parent's preferred language - breaking all communication barriers.</p>
                        <p className="text-[2.5vh]"><span className="text-[2.5vh] font-manropeB text-[black] tracking-wide">Instant 24/7 Updates →</span>Parents receive real-time alerts, day or night, keeping them always informed.</p>
                        <p className="text-[2.5vh]"><span className="text-[2.5vh] font-manropeB text-[black] tracking-wide">Reliable Automated Calls →</span> Unlike SMS (which <span className="text-[2.5vh] font-manropeB text-[black] tracking-wide">fails 20%</span> of the time), our automated calls ensure <span className="text-[2.5vh] font-manropeB text-[black] tracking-wide">100%</span> reach.</p>
                        <p className="text-[2.5vh]"><span className="text-[2.5vh] font-manropeB text-[black] tracking-wide">Personalized Student Alerts →</span> From attendance to exams, PTMs to fee reminders - every update is customized and timely.</p>
                    </div>
                </div>
                <div className="font-inter text-center">
                    <p className="text-smd_blue-normal text-[2.2vh] font-medium">Why settle for missed messages when you can have perfect communication?</p>
                </div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="container font-manrope p-7 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <h1 className="font-raveo text-smd_blue-normal text-4xl font-[1000] leading-[120%] tracking-[-1%]">Communications Made Easy</h1>
        //                     <p className="text-sm">🚫 Say NO to outdated methods that cause delays, confusion, and lost opportunities.</p>
        //                 </div>
        //                 <div className="flex justify-end col-span-2">
        //                 <AvatarVideo videoLinks={videoLinks} />
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="flex justify-center">
        //             <div className="w-fit bg-smd_white-normal border-2 border-smd_blue-normal rounded-3xl py-4 px-8">
        //                 <p className="text-smd_blue-normal text-lg font-manropeB">The Solution — Speak Their Language</p>
        //             </div>
        //         </div>
        //         <div className="flex justify-center">
        //             <div className="w-[70%] bg-smd_white-normal rounded-2xl p-4 text-[#081B34] space-y-6 border border-smd_golden-light">
        //                 <p className="text-sm"><span className="text-sm font-manropeB tracking-wide">Regional Language Support →</span>Our automated IVR system delivers messages in each parent's preferred language - breaking all communication barriers.</p>
        //                 <p className="text-sm"><span className="text-sm font-manropeB tracking-wide">Instant 24/7 Updates →</span>Parents receive real-time alerts, day or night, keeping them always informed.</p>
        //                 <p className="text-sm"><span className="text-sm font-manropeB tracking-wide">Reliable Automated Calls →</span> Unlike SMS (which <span className="text-sm font-manropeB tracking-wide">fails 20%</span> of the time), our automated calls ensure <span className="text-sm font-manropeB tracking-wide">100%</span> reach.</p>
        //                 <p className="text-sm"><span className="text-sm font-manropeB tracking-wide">Personalized Student Alerts →</span> From attendance to exams, PTMs to fee reminders - every update is customized and timely.</p>
        //             </div>
        //         </div>
        //         <div className="text-center">
        //             <p className="text-smd_blue-normal text-lg font-manropeB">Why settle for missed messages when you can have perfect communication?</p>
        //         </div>
        //         <Stepper />
        //     </div>
        // </div>
    );
}

export default CommPage3;